import { ResourceOccupancy, RetrieveOccupancyRequest } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  content: ResourceOccupancy[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
};

function getOccupancy(httpClient: HttpClient) {
  return (request: RetrieveOccupancyRequest) =>
    httpClient.sendHttpRequest<Response>({
      endpoint: "/capacity-planning/occupancy",
      method: HttpMethods.POST,
      data: {
        from: request.from,
        to: request.to,
        granularity: request.granularity,
        page: request.page,
        size: request.size,
        ...(request.filter && {
          filter: {
            zones: request.filter.zones?.map(({ uuid }) => uuid),
            projects: request.filter.projects?.map(({ uuid }) => uuid),
            projectsElementsTags: request.filter.projectsElementsTags?.map(
              ({ name }) => name,
            ),
            projectsTags: request.filter.projectsTags?.map(({ name }) => name),
            resources: request.filter.resources?.map(({ uuid }) => uuid),
            resourceTags: request.filter.resourceTags?.map(({ name }) => name),
            groups: request.filter.groups?.map(({ uuid }) => uuid),
            projectPortfolios: request.filter.projectPortfolios?.map(
              ({ uuid }) => uuid,
            ),
            projectStatuses: request.filter.projectStatuses?.map(
              ({ uuid }) => uuid,
            ),
            roles: request.filter.roles?.map(({ uuid }) => uuid),
          },
        }),
        ...(request.sort && { sort: request.sort }),
      },
    });
}

export { getOccupancy };
